<app-claim-summary [claimId]="claimId" [readOnly]="true"></app-claim-summary>